import styled, { css } from "styled-components";
import { Container } from "@material-ui/core";

const StyledController = styled(Container)`
  ${({ theme }) => {
    return css`
        overflow: hidden;
        width: 100vw;
        height: 100vh;
        background-color: #59656f;
        display: flex;
        padding: 10px 50px;
        text-align: center;
        font-family: 'Nunito', sans-serif;
        align-items: center;

        .MuiGrid-container {
          flex-wrap: nowrap;
        }

        .grid-item {
          margin-top: 12px;
          width: 100%;
        }

        .card {
          .card-actions {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
          }
        }

        .buttons-container {
          margin: 20px 20px;
          width: 50vw;
        }
        .info {
          position: absolute;
          bottom: 0;
          right: 0;
          flex-direction: row;
          background: white;
          padding: 4px;
          span {
            margin-left: 5px;
            color: #ff4444;
            &.online {
              color: #007e33;
            }
          }
        }
        .data-container {
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;

          .coda {
            background: white;
            box-sizing: border-box;
            flex-direction: row;
            padding: 4px 8px;
            margin: 4px 8px;
            p {
              margin: 2px 4px;
            }
          }
        }
        .warning {
          box-sizing: border-box;
          background: white;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;
          transition: opacity .3s ease-in-out;
          h3 {
            margin-left: 20px;
            margin-right: 20px;
            color: red;
          }
        }

        .accordion {
          .summary {
            flex-direction: row;
            align-items: center;
            svg {
              margin-right: ${theme.spacing(2)}px;
            }
          }
        }
    `;
  }}
`;

export default StyledController;
